// ─── Brand Assets ────────────────────────────────────────────────────────────
export const LOGO_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/logo_conceptB_ref_dragon_32f83f129231494aa91151501c336e70_9ca5bff64aa0460287c63181a3c7c29f.jpg";

// Logo symbol only (dragon + lotus, no text) — kept for reference
export const LOGO_SYMBOL_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/logo_symbol_57363901254847eba54f794d39f0fafa.jpg";

// Dragon+lotus+hands graphic only (no text) — used in hero composite
export const LOGO_DRAGON_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-20/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/logo_dragon_only_b2b9a99774054c13a90f479444efae05.png";

// Full logo / banner — front page hero logo area
export const LOGO_FULL_TRANSPARENT_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-21/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/yoyo_BANNER_transparent_190cc157ad9f4b90876c0f09236bc4de.png";

// Horizontal split logo — transparent PNG, front page hero only
export const LOGO_HORIZONTAL_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-20/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/logo_clean_v3_032e965c6f3b4086ae788cbd9902689f.png";

// Website logo — transparent PNG, used in Navbar and Footer
export const LOGO_WEBSITE_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-20/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/website_logo_transparent_f1a78bd8e0bc4d4f8e5e69ed8f181c06.png";

// ─── Service Icons (white background product style) ───────────────────────────
export const ICON_DRAGON =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/dragon_icon_white_dd2d33aabb8f4dfd952953d80e063d59.jpg";
export const ICON_HOTSTONE =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/hotstone_icon_clean_e965a92ea4bc415da63f4ba2d6236879.jpg";
export const ICON_MAGNETIC =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/magfork_icon_clean_25bf33a2cc2d411788ffa63be183c422.jpg";
export const ICON_FASCIA =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/fascia_icon_clean_1428a2c0c0bf49439e19f52236815385.jpg";
export const ICON_PELVIC =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/pelvic_icon_white_179c60961acb4693a57b808a7f119e2f.jpg";

// ─── Hero Illustration ────────────────────────────────────────────────────────
export const ILLUS_HERO =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-19/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/screen%200_e3df769c79ec448ab52346ae8c6c5071.jpg";

// ─── About Us Image ───────────────────────────────────────────────────────────
export const ABOUT_IMAGE =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-20/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/about%20us%20picture_baa756a34164406db8648e56d3911f1a.jpg";

// ─── Service Illustrations (user-provided photos) ─────────────────────────────
export const ILLUS_DRAGON =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-22/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/%E6%8A%93%E9%BE%8D%E7%AD%8B%E4%BF%9D%E5%81%A5%20new%20picture%204_ba00a207289644a4acef43e4f2b7db2f.png";
export const ILLUS_HOTSTONE =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-21/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/%E7%86%B1%E7%9F%B3%E6%8C%89%E6%91%A9%20picture_3c9debfef8664a8198fd80e92ab246cf.png";
export const ILLUS_MAGNETIC =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-21/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/%E7%A3%81%E5%8F%89%E6%92%A5%E7%AD%8B%E6%8C%89%E6%91%A9%20new%20picture%203_ce173e78340c40418e73412a46ebcd04.png";
export const ILLUS_FASCIA =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-22/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/%E7%AD%8B%E8%86%9C%E5%88%80%20picture%204_72bd9203d8d34cac8e7206258aea0bcc.png";
export const ILLUS_PELVIC =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-21/prod_agent_7c8c1f6b-7fcf-44ae-82ae-2247456b8c9a/%E9%AA%A8%E7%9B%86%E5%BA%95%E8%82%8C%E6%8C%89%E6%91%A9%20picture%204_c73a2b26e7e140ad993dd8b0bc5355c0.png";

// ─── Contact ──────────────────────────────────────────────────────────────────
export const CONTACT = {
  telegram: "https://t.me/Yoyoyo5387",
  whatsapp: "https://wa.me/85262516137",
  tgChannel: "https://t.me/yo5387",
  instagram: "https://www.instagram.com/yoyo_massage_wellness?utm_source=qr",
  twitter: "https://x.com/vivi80275642?s=11",
  location: "尖沙咀，香港",
};

// ─── Services ─────────────────────────────────────────────────────────────────
export interface ServiceData {
  id: string;
  slug: string;
  name: string;
  subtitle: string;
  description: string;
  benefits: string[];
  duration: string;
  icon: string;
  illustration: string;
  color: string;
}

export const SERVICES: ServiceData[] = [
  {
    id: "dragon-tendon",
    slug: "/services/dragon-tendon",
    name: "抓龍筋保健",
    subtitle: "源自古印度阿育吠陀，傳承泰國皇家養生秘技",
    description:
      "抓龍筋保健源自古印度阿育吠陀（Ayurveda），後傳入泰國皇家宮廷，演變為一套針對男性下腹及泌尿系統的深層養護手法。透過按摩特定穴位（如氣海、關元、中極）及相關筋絡，促進局部血液循環，舒緩因久坐、長期壓力造成的肌肉緊繃，讓氣血暢通，重拾精氣神。",
    benefits: [
      "促進下半身血液與淋巴循環",
      "活化泌尿生殖系統與代謝",
      "按摩特定穴位，調節體內氣機",
      "舒緩腰酸背痛及下肢疲勞",
      "提升精氣神，恢復身體活力",
    ],
    duration: "90 – 120 分鐘",
    icon: ICON_DRAGON,
    illustration: ILLUS_DRAGON,
    color: "#FFE000",
  },
  {
    id: "hot-stone",
    slug: "/services/hot-stone",
    name: "熱石按摩",
    subtitle: "天然玄武岩深層肌肉放鬆",
    description:
      "利用加熱至 45°C－60°C 的天然玄武岩石，結合香薰精油，將熱能傳導至深層肌肉。熱石的重量與溫度同步放鬆肌肉，促進血液循環，舒緩身心壓力，讓您感受溫暖而深層的放鬆體驗。",
    benefits: [
      "深層肌肉放鬆，迅速軟化僵硬",
      "促進血液與淋巴循環，加速新陳代謝",
      "改善睡眠品質，顯著降低焦慮感",
      "驅寒暖體，改善手腳冰冷",
      "配合香薰精油，釋放身心壓力",
    ],
    duration: "60 – 90 分鐘",
    icon: ICON_HOTSTONE,
    illustration: ILLUS_HOTSTONE,
    color: "#FF8C42",
  },
  {
    id: "magnetic-fork",
    slug: "/services/magnetic-fork",
    name: "磁叉撥筋按摩",
    subtitle: "磁力結合經絡穴位的深層養生療法",
    description:
      "磁叉按摩以帶有強力磁性的金屬工具，精準刺激穴位經絡。磁力能帶動血液中的鐵質流動，比單純人手按摩更深入刺激穴位與筋膜，達到疏通淋巴、消除肌肉疲勞、排走毒素、去水腫的效果。",
    benefits: [
      "疏通經絡，促進血液循環",
      "淋巴引流，排走毒素，去水腫",
      "解除筋膜沾黏，舒緩肌肉繃緊",
      "調節自律神經，改善睡眠質素",
      "無副作用的物理養生療法",
      "適合面部輪廓及全身淋巴按摩",
    ],
    duration: "60 – 90 分鐘",
    icon: ICON_MAGNETIC,
    illustration: ILLUS_MAGNETIC,
    color: "#4A90D9",
  },
  {
    id: "fascia-scraper",
    slug: "/services/fascia-scraper",
    name: "筋膜刀放鬆",
    subtitle: "工具輔助軟組織鬆動技術",
    description:
      "筋膜刀放鬆（IASTM）是一種以專業工具為輔助的軟組織鬆動手法，結合恆溫熱療、筋膜刮動與微震動技術。專注於解除筋膜沾黏，處理肌肉深層繃緊，配合精油進行深層按摩，令長期積聚的緊繃感得到全面釋放。",
    benefits: [
      "解除筋膜沾黏，恢復肌肉彈性",
      "恆溫熱療加持，深入筋膜層放鬆",
      "針對辦公室勞損，肩頸背腰繃緊",
      "促進軟組織自我修復",
      "適合運動後恢復及慢性肌肉繃緊",
    ],
    duration: "60 – 90 分鐘",
    icon: ICON_FASCIA,
    illustration: ILLUS_FASCIA,
    color: "#6B8F71",
  },
  {
    id: "pelvic-floor",
    slug: "/services/pelvic-floor",
    name: "骨盆底肌按摩",
    subtitle: "核心肌群調理與激活",
    description:
      "骨盆底肌是核心肌群的基底，負責支撐腹腔、調節腹內壓及多項生理功能。透過深層按摩手法，調節骨盆底肌肉張力，結合伸展與收縮的交替訓練，改善下腹不適、緊繃感，激活並強化相關肌群，讓身體從根本上獲得改善。",
    benefits: [
      "調節骨盆底肌肉張力，舒緩下腹緊繃",
      "激活核心肌群，增強肌肉功能",
      "改善排尿控制，減少尿頻不適",
      "促進骨盆腔血液循環",
      "配合筋膜放鬆，改善腰背酸痛",
    ],
    duration: "60 – 90 分鐘",
    icon: ICON_PELVIC,
    illustration: ILLUS_PELVIC,
    color: "#9B59B6",
  },
];
